module.exports = __webpack_public_path__ + "media/images/contact-envelope-fd5475c2dbfa0775386f7e5cd5707606.png";